import mediator from '../utilities/mediator';
import log from '../utilities/log';

import { Site } from '../models';
import {
  mutationOptions,
  queryOptions,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';
import { EntityState } from 'adc-sirius-module-common';

type SitesQueryParams = {
  studyKey?: string;
  state?: EntityState;
};

type SiteQueryParams = {
  key?: string;
};

type CreateSiteVariables = {
  site: Site;
};

type UpdateSiteVariables = {
  siteKey: Site['key'];
  updatedSiteValues: Partial<Site>;
};

export function sitesQueryOptions(
  params: SitesQueryParams,
  options?: Partial<UseQueryOptions<Site[]>>,
) {
  return queryOptions<Site[]>({
    ...options,
    queryKey: ['sites', params],
    queryFn: async () => {
      try {
        return await mediator.request<Site[]>('site:getSites', {
          ...params,
        });
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
    enabled: !!params.studyKey,
  });
}

export function siteQueryOptions(
  params: SiteQueryParams,
  options?: Partial<UseQueryOptions<Site>>,
) {
  return queryOptions<Site>({
    ...options,
    queryKey: ['site', params],
    queryFn: async () => {
      try {
        return await mediator.request<Site>('site:getSiteByKey', {
          ...params,
        });
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
    enabled: !!params.key,
  });
}

export function createSiteMutateOptions(
  options?: Partial<UseMutationOptions<Site, Error, CreateSiteVariables>>,
) {
  return mutationOptions<Site, Error, CreateSiteVariables>({
    ...options,
    mutationFn: async ({ site }: CreateSiteVariables) => {
      try {
        return await mediator.request<Site>('site:createSite', {
          data: site,
        });
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  });
}

export function updateSiteMutateOptions(
  options?: Partial<UseMutationOptions<Site, Error, UpdateSiteVariables>>,
) {
  return mutationOptions<Site, Error, UpdateSiteVariables>({
    ...options,
    mutationFn: async ({ updatedSiteValues }: UpdateSiteVariables) => {
      try {
        return await mediator.request<Site>('site:updateSite', {
          data: updatedSiteValues,
        });
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  });
}
